/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import './index.css';

interface SwitchProps {
  isLoading: boolean;
  checked: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DefaultSwitch: React.FC<SwitchProps> = ({ isLoading, checked, onChange }) => (
  <div>
    <label className="switch">
      <input disabled={isLoading} type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider round" />
    </label>
  </div>
);
